<div class="containerInfoPhone flex mx-auto md:col-span-4">
  <div class="containerLeftInfoPhone flex-none"></div>
  <div class="flex gap-x-3 py-3 pl-3 pr-6">
    <div class="flex items-center justify-center w-[65px] min-h-[65px]">
      <img [src]="imgInfo" alt="info-logo" [srcset]="imgInfo" />
    </div>
    <div class="flex grow item-center justify-center flex-col">
      <!-- {{ popUpInfo | json }} -->
      @if(popUpInfo) {
      <p *ngFor="let item of popUpInfo.texts" #textEvent class="text-P" [innerHTML]="item"></p>
      }
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showDialog"
  [header]="resource.infobulle.preferentialrate"
  [modal]="true"
  draggable="false"
  [style]="{ width: '400px' }"
  [dismissableMask]="true">
  <img
    *ngIf="getPath() !== undefined"
    [src]="'./assets/VYV/Images/PopUpInfo/' + getPath() + '.jpg'"
    [srcset]="'./assets/VYV/Images/PopUpInfo/' + getPath() + '.jpg'"
    alt="logo"
    [class]="className" />
</p-dialog>

